import { FormControl, FormGroup, Validators } from '@angular/forms';

export class LoginViewModel {
    email: string;
    password: string;

    constructor() {
        this.email = '';
        this.password = '';
    }

    toFormGroup(): FormGroup {
        const group: any = {};

        group.email = new FormControl(this.email || '', Validators.required);
        group.password = new FormControl(this.password || '', Validators.required);

        return new FormGroup(group);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/view-models/login.view-model.ts